import { useContext } from "react";
import { MdArrowForward } from "react-icons/md";
import { AppContext } from "../App";
import { projects } from "./ProjectsContent";

export default function HomeProjectSection() {
  const appContext = useContext(AppContext);
  const featuredProjects = projects.slice(0, 6);

  function goToProject(slug) {
    appContext.navTo({ item: "projects", subItem: slug });
  }

  return (
    <section className="tgm-section tgm-home-projects" data-aos="fade-up">
      <div className="container">
        <div className="tgm-home-section-top">
          <div>
            <h2>Our Latest Projects</h2>
            <p>
              Recent project highlights reflect SMART TGM Limited's practical
              construction experience across civil, building, and specialized
              works.
            </p>
          </div>
          <button
            type="button"
            className="tgm-solid-btn"
            onClick={() => appContext.navTo({ item: "projects" })}
          >
            View more
          </button>
        </div>

        <div className="tgm-project-grid">
          {featuredProjects.map((project, index) => (
            <article
              className="tgm-project-card"
              key={project.slug}
              role="button"
              tabIndex="0"
              data-aos="fade-up"
              data-aos-delay={index * 55}
              onClick={() => goToProject(project.slug)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  goToProject(project.slug);
                }
              }}
            >
              <div className="tgm-project-card-image">
                <img src={project.image} alt={project.name} />
              </div>
              <div className="tgm-project-card-body">
                <div>
                  <h3>{project.name}</h3>
                  <p>{project.status}</p>
                </div>
                <button
                  type="button"
                  aria-label={`View ${project.name}`}
                  onClick={(event) => {
                    event.stopPropagation();
                    goToProject(project.slug);
                  }}
                >
                  <MdArrowForward />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
